module.exports = __webpack_public_path__ + "img/file06.5761c27c.png";